type CallbackType<T> = (params: T) => void;
class EventBus<T> {
  name: string;
  callbacks: CallbackType<any>[];
  constructor(name: string) {
    this.name = name;
    this.callbacks = [];
  }
  subscribe(cb: CallbackType<T>) {
    this.callbacks.push(cb);
  }
  unsubscribe(cb: CallbackType<T>) {
    this.callbacks = this.callbacks.filter((c) => c !== cb);
  }
  emit(params?: T) {
    this.callbacks.forEach((cb) => {
      cb(params);
    });
  }
  emitOnce(params: T) {
    this.callbacks.forEach((cb) => {
      cb(params);
    });
    this.callbacks = [];
  }
}

export default EventBus;
